<template>
    <div class="modal-popup" v-if="display">
        <div class="popup" ref="modalPopup">
            <h4>{{ title }}</h4>
            <p v-html="subtitle"></p>

            <label class="modal-popup-checkbox" v-if="checkboxLabel.length">
                <input type="checkbox" v-model="checkboxChecked" />
                <span>{{ checkboxLabel }}</span>
            </label>

             <div class="buttons">
                <div class="button btn-outline-primary cancel" @click.stop="cancelModal" v-if="textCancel.length">
                    {{ textCancel }}
                </div>

                <div class="button btn-primary valid" @click.stop="validModal" v-if="textValid.length">
                    {{ textValid }}
                </div>
               
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {    

        data() {
            return {
                display: false,

                eventNameValid: null,
                eventNameCancel: null,
                textValid: '',
                textCancel: '',

                title:'',
                subtitle:'',
                params: null,
                // Auth.vue's cookie-consent (CMP) widget renders its own overlay outside this
                // component's DOM - a click on ITS buttons still counts as "outside our popup" for
                // handleClickOutside below, silently closing this modal too. Callers showing a
                // modal on a page with a 3rd-party overlay like that pass disableClickOutside=true
                // (8th arg) to opt out - button clicks (validModal/cancelModal) still close it.
                disableClickOutside: false,
                // Optional "don't ask me again"-style checkbox (9th arg, unchecked by default) -
                // its state is passed as the 1st argument to whichever function callback fires
                // (eventNameValid(checked)/eventNameCancel(checked)), so a caller can decide what
                // "don't ask again" should actually do (e.g. clearing some of its own storage).
                checkboxLabel: '',
                checkboxChecked: false

            }
        },

        mounted(){
            EventBus.$on('showModal', this.showModal);
        },

        methods: {

            showModal(title,subtitle,textBtnValid,textBtnCancel,actionValid,actionCancel,params,disableClickOutside,checkboxLabel) {
                console.log('showModal',{title,subtitle,textBtnValid,textBtnCancel,actionValid,actionCancel,params,disableClickOutside,checkboxLabel})
                this.title = title || '';
                this.subtitle = subtitle || '';
                this.textValid = textBtnValid || '',
                this.textCancel = textBtnCancel || '',
                this.eventNameValid = actionValid || null;
                this.eventNameCancel = actionCancel || null;
                this.params = params || null
                this.disableClickOutside = !!disableClickOutside
                this.checkboxLabel = checkboxLabel || ''
                this.checkboxChecked = false
                this.display = true
            },

            validModal() {
                console.log('validModal')
                if (this.eventNameValid) {
                    if (typeof this.eventNameValid === 'function') {
                        this.eventNameValid(this.checkboxChecked)
                    }else{
                        EventBus.$emit(this.eventNameValid,this.params)
                    }

                };
                this.resetData()
            },

            cancelModal() {
                console.log('cancelModal')
                if (this.eventNameCancel) {
                    if (typeof this.eventNameCancel === 'function') {
                        this.eventNameCancel(this.checkboxChecked)
                    }else{
                        EventBus.$emit(this.eventNameCancel,this.params);
                    }
                }
                this.resetData()
            },

            resetData() {
                console.log('resetDataModal')
                this.display = false;
                this.eventNameValid = null;
                this.eventNameCancel= null;
                this.title = '';
                this.subtitle = '';
                this.checkboxLabel = '';
                this.checkboxChecked = false;

            },

            handleClickOutside(event) {
                if (this.disableClickOutside) return
                console.log('handleClickOutside Modal')
                const targetElement = this.$refs.modalPopup;
                if (!targetElement.contains(event.target)) {
                    this.resetData()
                }
            },
        },

        watch : {
            display() {
                if (this.display) {   
                    setTimeout(() => {
                        window.addEventListener('click', this.handleClickOutside);
                    }, 200);  
                }else{
                    window.removeEventListener("click", this.handleClickOutside, false);
                }
            }
        },

        beforeDestroy() {
            EventBus.$off('showModal', this.showModal);
            window.removeEventListener("click", this.handleClickOutside);
        },
            
    }
</script>
